export default __webpack_public_path__ + "static/media/art-4-seedlings-lg.b3072fad.jpg";